import React, { useEffect, useRef, useState } from 'react';
import styles from './HomePage.module.css';

const KEYS_DEMO = [
  { type: 'w' }, { type: 'b' }, { type: 'w' }, { type: 'b' }, { type: 'w' },
  { type: 'w' }, { type: 'b' }, { type: 'w' }, { type: 'b' }, { type: 'w' },
  { type: 'b' }, { type: 'w' }, { type: 'w' }, { type: 'b' }, { type: 'w' },
  { type: 'b' }, { type: 'w' }, { type: 'w' },
];

export default function HomePage({ onCreate }) {
  const canvasRef = useRef(null);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animId;
    const particles = [];

    const resize = () => {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    for (let i = 0; i < 40; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vy: -(0.2 + Math.random() * 0.2),
        vx: (Math.random() - 0.5) * 0.2,
        size: 1 + Math.random() * 2,
        opacity: 0.1 + Math.random() * 0.3,
        symbol: ['♩','♪','♫','♬','instament','ai'][Math.floor(Math.random() * 6)],
      });
    }

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.y += p.vy;
        p.x += p.vx;
        if (p.y < -20) { p.y = canvas.height + 20; p.x = Math.random() * canvas.width; }
        ctx.font = `${12 + p.size * 4}px serif`;
        ctx.fillStyle = `rgba(200, 185, 122, ${p.opacity})`;
        ctx.fillText(p.symbol, p.x, p.y);
      });
      animId = requestAnimationFrame(draw);
    };
    draw();

    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener('resize', resize);
    };
  }, []);

  const handleCreate = () => {
    const audio = document.getElementById('Enter');
    if (audio) { audio.currentTime = 0; audio.play(); }
    setFading(true);
    setTimeout(onCreate, 1000);
  };

  return (
    <div className={styles.page}>
      <canvas ref={canvasRef} className={styles.canvas} />

      <div className={styles.content}>
        <div className={styles.tagline}>— powered by ElevenLabs &amp; Groq AI —</div>

        <h1 className={styles.title}>
          <em>Instament</em><br /><em>AI</em>
        </h1>

        <p className={styles.subtitle}>
          Describe any instrument and we lowkey make it real sometimes.<br />
          Hear it come to life in REAL TIME.
        </p>

        <div className={styles.demoKeys}>
          {KEYS_DEMO.map((k, i) => (
            <div key={i} className={k.type === 'w' ? styles.demoWhite : styles.demoBlack} />
          ))}
        </div>

        <audio id="Enter" src="/Enter.wav" />
        <button className={styles.createBtn} onClick={handleCreate}>
          Create an instrument
        </button>

        <div className={styles.examples}>
          <span>grand piano</span>
          <span>guitar</span>
          <span>underwater glass harp</span>
          <span>martian steel drums</span>
        </div>
      </div>

      <div className={styles.footer}>
        <p>&copy; 2026 Instament AI. Contact us at instament.ai@gmail.com for feedback or @instamentai for music clips.</p>
      </div>

      <div style={{
        position: 'fixed',
        inset: 0,
        background: 'white',
        opacity: fading ? 1 : 0,
        transition: 'opacity 0.8s ease',
        pointerEvents: 'none',
        zIndex: 999,
      }} />
    </div>
  );
}